<template>
  <div class="main-body" style="height: 40rem">
    <loading :active="isLoading" :is-full-page="fullPage" :loader="loader" />
    <div class="container" style="font-family: sans-serif">
      <div class="row" style="margin-top: 5rem">
        <div class="col-6" style="margin: auto">
          <div class="card text-white bg-dark mb-3 background">
            <div v-if="data.image_url == null" class="profile_img_section mt-3">
              <img
                class="profile_img mt-1"
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQAHUZX_s6WFf6ftWvY-0Zim-tARVWunDXjyrbnvaJsCYDk5GA7HckdhGEvk5R80Io-7Ak&usqp=CAU"
              />
              <label
                for="c_image"
                v-if="updateForm"
                class="profile_img_upload_btn"
              >
                <i
                  class="fa fa-camera fa-2x profile_img_upload_btn"
                  style="color: rgb(181 46 225 / 77%); cursor: pointer"
                ></i>
              </label>
            </div>
            <div v-else class="profile_img_section mt-3">
              <img class="profile_img mt-1" :src="data.image_url" />
              <label
                for="c_image"
                v-if="updateForm"
                class="profile_img_upload_btn"
              >
                <i
                  class="fa fa-camera fa-2x profile_img_upload_btn"
                  style="color: rgb(181 46 225 / 77%); cursor: pointer"
                ></i>
              </label>
            </div>

            <div class="edit_btn_section">
              <i
                v-on:click="editSection()"
                class="fa fa-edit fa-2x"
                style="cursor: pointer"
              ></i>
            </div>
            <div v-if="!updateForm" class="card-body">
              <h5 class="card-title"><b>Personal Information</b></h5>
              <p class="card-text">
                <label><b>Name:</b></label
                >&nbsp;{{ data.full_name ? data.full_name : "Not available" }}
              </p>
              <!-- <p class="card-text">
                <label
                  ><b>{{ data.user_name.includes("@") ? "Email" : "Mobile" }}</b></label
                >&nbsp;{{ data.user_name ? data.user_name : "Not available" }}
              </p> -->
              <p class="card-text">
                <label><b>City:</b></label
                >&nbsp;{{ data.city ? data.city : "Not available" }}
              </p>
              <p class="card-text">
                <label><b>Address:</b></label
                >&nbsp;{{ data.address ? data.address : "Not available" }}
              </p>
              <p class="card-text">
                <label><b>Post Code:</b></label
                >&nbsp;{{ data.post_code ? data.post_code : "Not available" }}
              </p>
              <h6 v-if="data.premium == 1"><b>Premium:</b>&nbsp;Yes</h6>
              <h6 v-else><b>Premium:</b>&nbsp;No</h6>
            </div>
            <div v-else class="card-body">
              <form @submit.prevent="processForm">
                <div class="image-upload">
                  <input
                    type="file"
                    name="c_image"
                    id="c_image"
                    aria-describedby="imageHelp"
                    accept="image/*"
                    @change="onImageFileChange"
                  />
                </div>
                <div class="form-group">
                  <label for="exampleInputEmail1">Full Name</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="fullName"
                    placeholder="Enter full name"
                  />

                  <label for="exampleInputEmail1">Email</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="phone_email"
                    placeholder="Enter Your Number"
                  />

                  <label for="exampleInputEmail1">City</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="cityName"
                    placeholder="Enter City name"
                  />

                  <label for="exampleInputEmail1">Address</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="address"
                    placeholder="Enter full name"
                  />

                  <label for="exampleInputEmail1">post Code</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="postCode"
                    placeholder="Enter Post Code"
                  />
                </div>
                <button type="submit" class="btn btn-primary mt-2">
                  Submit
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Loading from "vue-loading-overlay";
export default {
  name: "Profile",
  components: { Loading },
  data() {
    return {
      data: [],
      img: true,
      updateForm: false,
      fullName: localStorage.getItem(this.$fullName),
      phone_email: "",
      cityName: "",
      address: "",
      postCode: "",
      profileImage: localStorage.getItem(this.$profileImage),
      //for loader
      isLoading: false,
      fullPage: true,
      loader: "bars",
      selectedImageFile: undefined,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    onImageFileChange(event) {
      this.selectedImageFile = event.target.files[0];
    },
    processForm() {
      //console.log(this.fullName, this.phoneNo, this.cityName, this.address, this.postCode, this.selectedImageFile);
      if (this.selectedImageFile) {
        this.updateProfile();
      } else {
        this.updateProfilewithoutImage();
      }
    },
    editSection() {
      this.updateForm = !this.updateForm;
    },
    async getData() {
      this.isLoading = true;
      const token = localStorage.getItem(this.$tokenKey);
      const id = localStorage.getItem(this.$idKey);
      try {
        const res = await axios.get(
          this.$baseUrl + this.$api + this.$version1 + "/users/" + id,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        this.isLoading = false;
        if (res.status == 200) {
          console.log(res.data);
          localStorage.setItem(this.$fullName, res.data.full_name);
          localStorage.setItem(this.$profileImage, res.data.image_url);
          this.data = res.data;
        } else {
          this.$vToastify.error("Could not fetch data!");
        }
      } catch (error) {
        this.isLoading = false;
        console.log(error);
      }
    },

    async updateProfile() {
      //console.log("IN update profile")
      const formData = new FormData();
      formData.append("full_name", this.fullName);
      formData.append("phone_email", this.phone_email);
      formData.append("city_name", this.cityName);
      formData.append("address", this.address);
      formData.append("post_code", this.postCode);
      formData.append("files", this.selectedImageFile);
      const token = localStorage.getItem(this.$tokenKey);
      try {
        this.isLoading = true;
        const token = localStorage.getItem(this.$tokenKey);
        const id = localStorage.getItem(this.$idKey);
        const res = await axios.put(
          this.$baseUrl + this.$api + this.$version1 + "/users/update/" + id,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            },
          }
        );
        this.isLoading = false;
        this.updateForm = false;
        console.log(res);
        if (res.status == 200) {
          this.getData();
          this.$router.go();
        }
      } catch (error) {
        console.log(error);
      }
    },

    async updateProfilewithoutImage() {
      //console.log("IN update profile without imaged")
      try {
        this.isLoading = true;
        const token = localStorage.getItem(this.$tokenKey);
        const id = localStorage.getItem(this.$idKey);
        const res = await axios.put(
          this.$baseUrl +
            this.$api +
            this.$version1 +
            "/users/update/withoutImage/" +
            id,
          {
            full_name: this.fullName,
            phone_email: this.phone_email,
            city_name: this.cityName,
            address: this.address,
            post_code: this.postCode,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        this.isLoading = false;
        this.updateForm = false;
        console.log(res);
        if (res.status == 200) {
          localStorage.setItem(this.$fullName, this.fullName);
          this.$router.go();
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {},
  watch: {
    data: function (newVal, oldVal) {
      this.phone_email = this.data.user_name;
      this.cityName = this.data.city;
      this.address = this.data.address;
      this.postCode = this.data.post_code;
    },
  },
};
</script>

<style scoped>
.profile_img_section {
  height: 150px;
  width: 150px;
  margin: 0 auto 20px auto;
  position: relative;
}
.edit_btn_section {
  height: 10px;
  width: 15px;
  margin: 0 auto 20px auto;
  margin-left: 32rem;
  position: absolute;
  top: -5px;
  right: 12px;
}
.profile_img {
  height: 100%;
  width: 100%;
  object-fit: cover;
  border-radius: 50%;
  display: block;
}
.profile_img_upload_btn {
  position: absolute;
  bottom: 5px;
  right: 0;
}
.background {
  background: linear-gradient(to right, #1a354e 0.87%, #4e2d8a 99.92%);
}

.image-upload > input {
  display: none;
}
</style>
